import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon, CalendarIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/fx/Reveal';
const POSTS = [{
  title: '5 Signs of Hidden Water Damage in Your Home',
  excerpt: "Water damage often lurks out of sight. Here's how to spot the early warning signs before they become costly.",
  category: 'Water Damage',
  date: 'July 2, 2026',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/311a9ceb-fc01-4d4a-96b1-95c70a6df5c0.jpg'
}, {
  title: 'Preparing Your Houston Home for Storm Season',
  excerpt: 'A practical checklist to protect your property before the next major storm rolls through the Gulf Coast.',
  category: 'Storm Damage',
  date: 'June 18, 2026',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/18ee5201-6753-417b-a971-44162ee3c549.jpg'
}, {
  title: 'How to Plan a Luxury Remodel That Adds Value',
  excerpt: 'From kitchens to full renovations — the design decisions that deliver the biggest return on your investment.',
  category: 'Remodeling',
  date: 'May 30, 2026',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c64a04af-4515-4fb8-8b45-042898bc3c80.jpg'
}];
export function Blog() {
  return <>
      <PageHero eyebrow="Insights" title="The Dream Shield Journal" subtitle="Expert guidance on restoration, protection, and elevating your home." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Blog'
    }]} data-id="element-414" data-mp="1j6rlwald9hpb" />

      <section className="mx-auto max-w-7xl px-6 py-8" data-id="element-415" data-mp="1x72dxgyex2c2">
        <div className="grid gap-8 md:grid-cols-3" data-id="element-416" data-mp="33mlgnd7q7h4t">
          {POSTS.map((post, i) => <Reveal key={post.title} delay={i * 0.1} data-id="element-417" data-mp="38lfxwaq1oxmt" data-mpi={i}>
              <motion.article whileHover={{
            y: -8
          }} className="group h-full overflow-hidden rounded-[2rem] bg-white shadow-glass transition-shadow hover:shadow-glow" data-id="element-418" data-mp="38k4wuinzi3ze">
                <div className="relative aspect-[3/2] overflow-hidden" data-cursor="image" data-id="element-419" data-mp="1ih49f2tl4dss">
                  <img src={post.image} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-420" data-mp="1djkv62ww010u" />
                  <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-royal" data-id="element-421" data-mp="zk339eoao7n9">
                    {post.category}
                  </span>
                </div>
                <div className="p-7" data-id="element-422" data-mp="70cx47ynpke6">
                  <p className="flex items-center gap-1.5 text-xs text-slate" data-id="element-423" data-mp="23e2zpeztdfz">
                    <CalendarIcon className="h-3.5 w-3.5" data-id="element-424" data-mp="21a11d0nmoic" /> {post.date}
                  </p>
                  <h2 className="mt-3 font-display text-lg font-bold leading-snug text-navy" data-id="element-425" data-mp="2dod9jvzek2wf">
                    {post.title}
                  </h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-426" data-mp="24qkv0u1i8za3">
                    {post.excerpt}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-royal" data-id="element-427" data-mp="28rmth8nll7b0">
                    Read Article
                    <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-428" data-mp="31fsg60y7p6dh" />
                  </span>
                </div>
              </motion.article>
            </Reveal>)}
        </div>
      </section>
    </>;
}